import { PerformanceObserverEntryTypes } from "../../const";

export class BufferWithMaxLength<T> {
    public buffer: Array<T> = [];

    public maxLength: number;

    public full = false;

    public constructor(maxLength = 1000) {
        this.maxLength = maxLength;
    }

    public push(item: T) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }

    public getAll() {
        return this.buffer;
    }
}

export type EntriesBufferType = {
    [key: string]: BufferWithMaxLength<PerformanceEntry>;
};
export type PerformanceEntryBuffer = BufferWithMaxLength<PerformanceEntry>;

export const EntriesBuffer: EntriesBufferType = {
    [PerformanceObserverEntryTypes.LongTask]:
        new BufferWithMaxLength<PerformanceEntry>(),
    [PerformanceObserverEntryTypes.LayoutShift]:
        new BufferWithMaxLength<PerformanceEntry>()
};
